/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import AlphabeticalLanding from '../components/AlphabeticalLanding';
import BlogCategoryListing from '../components/BlogCategoryListing';
import BlogListing from '../components/BlogListing';
import BorderCallout from '../components/BorderCallout';
import Breadcrumbs from '../components/Breadcrumbs';
import Callout from '../components/Callout';
import CodeInjection from '../components/CodeInjection';
import ConsentChecker from '../components/ConsentChecker';
import ContentBlock from '../components/ContentBlock';
import CoveoGeneralSearch from '../components/Coveo/CoveoGeneralSearch';
import CoveoPhysiciansSearch from '../components/Coveo/CoveoPhysiciansSearch';
import CoveoSearchBox from '../components/Coveo/CoveoSearchBox';
import EmergencyAlert from '../components/EmergencyAlert';
import Footer from '../components/Footer';
import FooterBanner from '../components/FooterBanner';
import CustomFieldFactory from '../components/Forms/CustomFieldFactory';
import CustomFieldValidationErrors from '../components/Forms/CustomFieldValidationErrors';
import GoogleRecaptcha from '../components/Forms/GoogleRecaptcha';
import RawHtml from '../components/Forms/RawHtml';
import ReactSitecoreForm from '../components/Forms/ReactSitecoreForm';
import FourColumnContentRow from '../components/FourColumnContentRow';
import Header from '../components/Header';
import HeaderLogoOnly from '../components/HeaderLogoOnly';
import HeroBannerWithSearch from '../components/HeroBannerWithSearch';
import ImageCard from '../components/ImageCard';
import JobPostingDetailsContent from '../components/JobPostingDetailsContent';
import JobPostingListing from '../components/JobPostingListing';
import KalturaEmbeddedMedia from '../components/KalturaEmbeddedMedia';
import LanguageSelector from '../components/LanguageSelector';
import Logo from '../components/Logo';
import LogoBanner from '../components/LogoBanner';
import MarketingAlert from '../components/MarketingAlert';
import DrilldownMenu from '../components/Navigation/DrilldownMenu';
import LeftNavigation from '../components/Navigation/LeftNavigation';
import LinkList from '../components/Navigation/LinkList';
import MobileNavigation from '../components/Navigation/MobileNavigation';
import ScrollToTop from '../components/Navigation/ScrollToTop';
import OneColumnContentRowFullWidth from '../components/OneColumnContentRowFullWidth';
import OneColumnContentRowWithMargins from '../components/OneColumnContentRowWithMargins';
import PageHero from '../components/PageHero';
import PageProperties from '../components/PageProperties';
import PartialDesignDynamicPlaceholder from '../components/PartialDesignDynamicPlaceholder';
import PhysicianDetailsContent from '../components/PhysicianDetailsContent';
import ResponsiveImage from '../components/ResponsiveImage';
import RichTextEditor from '../components/RichTextEditor';
import BlogPageSchema from '../components/Schemas/BlogPageSchema';
import ContactPageSchema from '../components/Schemas/ContactPageSchema';
import HospitalPageSchema from '../components/Schemas/HospitalPageSchema';
import NewsPageSchema from '../components/Schemas/NewsPageSchema';
import SearchField from '../components/SearchField';
import SearchResults from '../components/SearchResults';
import SectionFullWidth from '../components/SectionFullWidth';
import SectionWithMargin from '../components/SectionWithMargin';
import SimpleFooter from '../components/SimpleFooter';
import SiteMapLinkListing from '../components/SiteMapLinkListing';
import SkipToContent from '../components/SkipToContent';
import JobPostingDetails from '../components/SubLayouts/JobPostingDetails';
import OneColumn from '../components/SubLayouts/OneColumn';
import TwoColumnwithLeftNav from '../components/SubLayouts/TwoColumnwithLeftNav';
import SubSiteNav from '../components/SubSiteNav';
import ThreeColumnContentRow from '../components/ThreeColumnContentRow';
import TwoColumnContentRow from '../components/TwoColumnContentRow';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AlphabeticalLanding', AlphabeticalLanding);
components.set('BlogCategoryListing', BlogCategoryListing);
components.set('BlogListing', BlogListing);
components.set('BorderCallout', BorderCallout);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Callout', Callout);
components.set('CodeInjection', CodeInjection);
components.set('ConsentChecker', ConsentChecker);
components.set('ContentBlock', ContentBlock);
components.set('CoveoGeneralSearch', CoveoGeneralSearch);
components.set('CoveoPhysiciansSearch', CoveoPhysiciansSearch);
components.set('CoveoSearchBox', CoveoSearchBox);
components.set('EmergencyAlert', EmergencyAlert);
components.set('Footer', Footer);
components.set('FooterBanner', FooterBanner);
components.set('CustomFieldFactory', CustomFieldFactory);
components.set('CustomFieldValidationErrors', CustomFieldValidationErrors);
components.set('GoogleRecaptcha', GoogleRecaptcha);
components.set('RawHtml', RawHtml);
components.set('ReactSitecoreForm', ReactSitecoreForm);
components.set('FourColumnContentRow', FourColumnContentRow);
components.set('Header', Header);
components.set('HeaderLogoOnly', HeaderLogoOnly);
components.set('HeroBannerWithSearch', HeroBannerWithSearch);
components.set('ImageCard', ImageCard);
components.set('JobPostingDetailsContent', JobPostingDetailsContent);
components.set('JobPostingListing', JobPostingListing);
components.set('KalturaEmbeddedMedia', KalturaEmbeddedMedia);
components.set('LanguageSelector', LanguageSelector);
components.set('Logo', Logo);
components.set('LogoBanner', LogoBanner);
components.set('MarketingAlert', MarketingAlert);
components.set('DrilldownMenu', DrilldownMenu);
components.set('LeftNavigation', LeftNavigation);
components.set('LinkList', LinkList);
components.set('MobileNavigation', MobileNavigation);
components.set('ScrollToTop', ScrollToTop);
components.set('OneColumnContentRowFullWidth', OneColumnContentRowFullWidth);
components.set('OneColumnContentRowWithMargins', OneColumnContentRowWithMargins);
components.set('PageHero', PageHero);
components.set('PageProperties', PageProperties);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('PhysicianDetailsContent', PhysicianDetailsContent);
components.set('ResponsiveImage', ResponsiveImage);
components.set('RichTextEditor', RichTextEditor);
components.set('BlogPageSchema', BlogPageSchema);
components.set('ContactPageSchema', ContactPageSchema);
components.set('HospitalPageSchema', HospitalPageSchema);
components.set('NewsPageSchema', NewsPageSchema);
components.set('SearchField', SearchField);
components.set('SearchResults', SearchResults);
components.set('SectionFullWidth', SectionFullWidth);
components.set('SectionWithMargin', SectionWithMargin);
components.set('SimpleFooter', SimpleFooter);
components.set('SiteMapLinkListing', SiteMapLinkListing);
components.set('SkipToContent', SkipToContent);
components.set('JobPostingDetails', JobPostingDetails);
components.set('OneColumn', OneColumn);
components.set('TwoColumnwithLeftNav', TwoColumnwithLeftNav);
components.set('SubSiteNav', SubSiteNav);
components.set('ThreeColumnContentRow', ThreeColumnContentRow);
components.set('TwoColumnContentRow', TwoColumnContentRow);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
